module.exports = __webpack_public_path__ + "img/filter.23dfefb3.svg";